<template>
    <div id="student-course-view" :class="{'preview-course-padding' : preview || freeCourse}">
        <div v-if="!preview && !freeCourse" class="student-top-bar">
            <div class="subnav-content">
                <nav role="navigation" class="nav-menu-2 w-nav-menu">
                    <!--  <circle-slider v-model="sliderValue" :side="53" :min="0" :max="100" :step-size="1" :circleWidth="5" :circle-width-rel="1" :progress-width="5" :knob-radius="10" circleColor="#808080" progressColor="#f77f00" ></circle-slider> <div class="slider-text">{{sliderValue}}%</div> -->
                    <div class="subnav-link">
                        <progress-ring :min="0" :max="100" :value="sliderValue" :text="sliderValue"></progress-ring>
                    </div>
                    <div class="subnav-link">
                        <world-clock :icon-mode="true" :course-bar-color="true"
                                     @click="showWorldClocks = true"></world-clock>
                    </div>
                    <div class="subnav-link hover-image" v-on:click="showChat = true"><img
                        :src="'/images/Chat-Course-Blue.png'" style="opacity: 1;" class="inactive-icon"/><img
                        :src="'/images/chat-orange.png'" style="opacity: 0;" class="active-icon"/>
                        <div v-if="unreadChatMessages" class="notification badge"
                             :class="{ fontxsmall: unreadChatMessages < 100 }">
                            {{ unreadChatMessages < 100 ? unreadChatMessages : "99+" }}
                        </div>
                    </div>
                    <div class="subnav-link hover-image" @click="showCalendarModal = true"><img class="inactive-icon"
                                                                                                style="opacity: 1;"
                                                                                                :src="'/images/Calendar-blue.png'"/><img
                        :src="'/images/calendar-orange.png'" style="opacity: 0;" class="active-icon"/>
                        <div v-if="false" class="notification"></div>
                    </div>
                    <div class="subnav-link hover-image" v-on:click="showStudentKeep = true"><img class="inactive-icon"
                                                                                                  style="opacity: 1;"
                                                                                                  :src="'/images/Main-Navy-Blue.png'"/><img
                        :src="'/images/keep-main-orange.png'" style="opacity: 0;" class="active-icon"/></div>
                </nav>
            </div>
        </div>
        <div class="w-layout-grid content-3-col-grid" :class="!preview && !freeCourse ? 'student-course-wrapp' : ''">
            <div class="side-content mobile-hide">
                <div class="fixed-parent">
                    <div class="fixed pr-2" :class="{'preview-course-fixed-padding' : preview || freeCourse}">
                        <div class="section-title-wrap d-flex" style="justify-content: space-between">
                            <h2 class="section-title mr-2">{{ courseName }}</h2>
                            <div class="mt-1">
                                <i v-if="passedLessonsHidden" aria-hidden="true" class="far fa-eye" style="color: #333" :title="trans('course')['student_course_map.show_all']" @click.prevent="togglePassed"></i>
                                <i v-else aria-hidden="true" class="far fa-eye-slash" style="color: #333" :title="trans('course')['student_course_map.hide_completed']" @click.prevent="togglePassed"></i>
                            </div>
                        </div>
                        <div class="section-map">
                            <div v-for="(element, sid) in map">
                                <div :class="'course-map-' + element.type" class="map-first">
                                    <div class="map-wrapp" @click="expandMap($event, element)">
                                        <a @click="mapClick(element.iId)" :id="'section-' + element.iId"
                                           class="map-section pointer"
                                           v-bind:class="{ active: element.iId == active }">
                                            {{
                                                element.name ? element.name : trans('course.untitled.' + (isNaN(element.type) ? element.type : 'chapter'))
                                            }}
                                            <template
                                                v-if="!element.hideMinutes && (element.minutes || element.seconds)">
                                                (
                                                <template v-if="element.minutes">{{ element.minutes }} m</template>
                                                <template v-if="element.seconds"> {{ element.seconds }} s</template>
                                                )
                                            </template>
                                        </a><i v-if="element.type == 1 && element.children.length"
                                               class="fas fa-angle-down"></i></div>
                                    <div class="children-map" :class="'children-' + element.iId">
                                        <div v-for="child in element.children" :class="'map-' + child.type">
                                            <a @click="mapClick(child.iId)" :id=" 'creator-map-' + child.iId"
                                               class="map-section child-map pointer"
                                               :class="{ active: child.iId == active }">
                                                <div
                                                    class="chapter-item"
                                                    :id=" 'map-' + child.type + '-' + (child.type == 'quiz' ? child.quiz_id : child.id)">
                                                    {{
                                                        child.name ? child.name : trans('course.untitled.' + (isNaN(child.type) ? child.type : 'chapter'))
                                                    }}
                                                    <template v-if="!child.hideMinutes && (child.minutes || child.seconds)">
                                                        (
                                                        <template v-if=" child.minutes">{{ child.minutes }} m</template>
                                                        <template v-if=" child.seconds"> {{ child.seconds }} s</template>
                                                        )
                                                    </template>
                                                </div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="middle-content middle-content-initial-state with-subnav">
                <template>
                    <!--   <div v-if="passedCourse" class="alert alert-success text-center" role="alert"> You passed the course successfully. </div> -->
                    <div v-if="!courseDone && !courseNoPased" id="course-wrapp">
                        <div v-for="(section, ids) in sections" :key="section.id + Math.random()">
                            <template v-if="active == ids">
                                <div v-if="!section.qid" class="course-section" :id="'section-' + section.id"><h2
                                    class="section-title mb">
                                    {{
                                        section.name ? section.name : trans('course.untitled.' + (isNaN(section.type) ? section.type : 'chapter'))
                                    }}</h2>
                                    <!--                                    <h5 v-if=" section.minutes || section.seconds">-->
                                    <!--                                        <template v-if="section.minutes">{{ section.minutes }} minutes</template>-->
                                    <!--                                        <template v-if=" section.minutes && section.seconds">:</template>-->
                                    <!--                                        <template v-if="section.seconds">{{ section.seconds }} seconds</template>-->
                                    <!--                                    </h5>-->
                                    <div
                                        v-if="section.descriptionBlocks && section.descriptionBlocks != '' && section.type !='lesson'">
                                        <course-blocks v-on:trigger-keep="triggerKeep" :idl="section.id" :ids="ids"
                                                       :section="section" :token="token"
                                                       :content="section.descriptionBlocks ? JSON.parse(section.descriptionBlocks) : []"></course-blocks>
                                    </div>
                                    <div v-if="section.type == 'lesson'" v-scroll="onScroll">
                                        <course-blocks v-on:trigger-keep="triggerKeep" :idl="section.id" :ids="ids"
                                                       :section="section" :token="token"
                                                       :content="section.content ? JSON.parse(section.content) : []"></course-blocks>
                                    </div>
                                    <div v-if=" section.goalBlocks && section.goalBlocks != ''"><p class="ck-content"
                                                                                                   v-html="section.goal"></p>
                                    </div>
                                </div>
                                <div v-else>
                                    <course-quiz-part v-on:trigger-keep="triggerKeep" :courseId="id"
                                                      :studentCourseId="studentCourseId" :ids="ids" :idl="section.id"
                                                      :section="section" :preview="preview" :freeCourse="freeCourse" :user="student"
                                                      :quiz="section.quiz" v-on:quizDone="updateCourseStatus"
                                                      @navigate-back="navigateBack(ids)"></course-quiz-part>
                                </div>
                                <div class="border-course mb"></div>
                                <div class="flex spaced" style="margin-bottom: 30px">
                                    <div><a v-if="ids != 0" @click="prevSection(ids)" class="next-button">&lt;&nbsp;{{
                                            trans("course.student_course_previous")
                                        }}</a></div><!--  <a class="next-button">&lt;&nbsp;Previous</a> --><a
                                    @click="nextSection(ids)" class="next-button">{{
                                        displayFinishButton ? trans("course.student_course_finish") : trans("course.student_course_next")
                                    }} &gt;</a>
                                </div>
                            </template>
                        </div>
                    </div>
                    <div v-if="courseNoPased" class="course-pass">
                        <template v-if="courseNoPased"><i class="fas fa-exclamation-triangle"></i>
                            <h2 class="mt-5">{{ trans("course.student_course_incomplete") }}!</h2>
                            <p>{{ courseNoPased }}</p></template>
                    </div>
                    <div v-if="courseDone">
                        <div class="course-pass">
                            <template><i class="fas fa-check-circle"></i>
                                <h2 class="mt-5">{{ trans("course.student_course_congratulations") }}!</h2>
                                <p>{{ courseFinishMessage }}</p><a
                                    v-if=" showCertificate && certificate && typeof certificate.id != 'undefined'"
                                    href="/user-certificates"
                                    class="text-link">{{ trans("course.student_course_get_certificate") }}</a>
                            </template>
                        </div>
                    </div>
                </template>
            </div>
            <div class="side-content right side-right-initial-state">
                <div class="mobile-show">
                    <div class="mobile-tabs-menu w-tab-menu"><a @click="mobileTab = 'map'"
                                                                class="mobile-tab-link w-inline-block w-tab-link"
                                                                :class="mobileTab == 'map' ? 'w--current' : ''">
                        <div>{{ trans("course.student_course_map") }}</div>
                    </a><a @click="mobileTab = 'goals'" class="mobile-tab-link w-inline-block w-tab-link"
                           :class="mobileTab == 'goals' ? 'w--current' : ''">
                        <div>{{ trans("course.student_course_goals") }}</div>
                    </a></div>
                    <div v-if="course.user && mobileTab == 'goals'" class="mobile-wrapp">
                        <ol class="goals-list">
                            <template v-if=" typeof sections[active]?.goals != 'undefined'"
                                      v-for="goal in sections[active]?.goals">
                                <li v-if="goal && goal != ''" class="list-item">
                                    <div v-html="goal"></div>
                                </li>
                            </template>
                        </ol>
                    </div>
                    <div class="mobile-wrapp" v-if="mobileTab == 'map'">
                        <div class="section-map">
                            <div v-for="(element, sid) in map">
                                <div :class="'course-map-' + element.type" class="map-first">
                                    <div class="map-wrapp" @click="expandMap($event, element)"><a
                                        @click="mapClick(element.iId)" :id="'section-' + element.iId"
                                        class="map-section pointer" v-bind:class="{ active: element.iId == active }">
                                        {{
                                            element.name ? element.name : trans('course.untitled.' + (isNaN(element.type) ? element.type : 'chapter'))
                                        }}
                                        <template v-if=" element.minutes || element.seconds">(
                                            <template v-if="element.minutes">{{ element.minutes }}
                                                {{ trans("course.student_course_min") }}
                                            </template>
                                            <template v-if="element.seconds">{{ element.seconds }}
                                                {{ trans("course.student_course_sec") }}
                                            </template>
                                            )
                                        </template>
                                    </a><i v-if="element.type == 1 && element.children.length"
                                           class="fas fa-angle-down"></i></div>
                                    <div class="children-map" :class="'children-' + element.iId">
                                        <div v-for="child in element.children" :class="'map-' + child.type">
                                            <div
                                                :id=" 'map-mobile-' + child.type + '-' + (child.type == 'quiz' ? child.quiz_id : child.id)">
                                                <a @click="mapClick(child.iId)" :id=" 'creator-map-' + child.iId"
                                                   :href=" '#element-' + child.iId"
                                                   class="map-section child-map pointer"
                                                   :class="{ active: child.iId == active }">
                                                    {{
                                                        child.name ? child.name : trans('course.untitled.' + (isNaN(child.type) ? child.type : 'chapter'))
                                                    }}
                                                    <template v-if=" child.minutes || child.seconds">(
                                                        <template v-if="child.minutes">{{ child.minutes }}
                                                            {{ trans("course.student_course_min") }}
                                                        </template>
                                                        <template v-if="child.seconds">{{ child.seconds }}
                                                            {{ trans("course.student_course_sec") }}
                                                        </template>
                                                        )
                                                    </template>
                                                </a></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="fixed-parent quizzes mobile-hide">
                    <div class="fixed pr-2" :class="{'preview-course-fixed-padding' : preview || freeCourse}">
                        <template v-if="course.user">
                            <div class="section-title-wrap"><h2 class="section-title">
                                {{ trans("course.student_course_goals") }}</h2></div>
                            <ol class="goals-list">
                                <template v-if=" typeof sections[active]?.goals != 'undefined'"
                                          v-for="goal in sections[active]?.goals">
                                    <li v-if="goal && goal != ''" class="list-item no-box">
                                        <div class="pl-0 pr-0 mt-2 text-break" v-html="goal"></div>
                                    </li>
                                </template>
                            </ol>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <world-clocks-modal v-if="showWorldClocks" @modal-closed="showWorldClocks = false"/>
        <student-keep v-if="showStudentKeep" :course-keep-sections="keepSections" :free-course="!!freeCourse"
                      :preview="!!preview" :trigger-data="keepTriggerData" :student="student"
                      :student-course-id="studentCourseId" :course-name="course.name" @modal-closed="keepModalClosed"
                      :read-only="false"/>
        <student-calendar-modal v-if="showCalendarModal" @close="showCalendarModal = false"/>
        <chat v-if="!preview && !freeCourse && userId" :user="userId" :show-chat="showChat"
              @chat-closed="showChat = false" @unread-messages="updateUnreadChatMessages"></chat>
        <div class="modal fade" id="previewCertificateModal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered  modal-xl" role="document">
                <div class="modal-content">
                    <div class="modal-header"><h5 class="modal-title">{{ courseName }} Certificate</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span
                            aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="modal-body" v-if=" certificate && typeof certificate.id != 'undefined'">
                        <div class="position-relative" v-for="(template, index) in certificate.templates"
                             v-if="index < certificate.pages">
                            <img class="w-100 img-responsive" :src="'/images/cerrificate.jpg'"/>
                            <div
                                v-bind:style="{ top: certificate.alignment_top + 'px', bottom: certificate.alignment_bottom + 'px', right: certificate.alignment_right + 'px', left: certificate.alignment_left + 'px' }"
                                v-html="template" class="certificate-wrap"></div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import WorldClocksModal from "./CourseParts/WorldClocksModal";
import WorldClock from "./CourseParts/WorldClock";
import Chat from "./Chat";
import StudentCalendarModal from "./StudentCalendarModal";
import StudentKeep from "./StudentKeep";
import toastr from "toastr";

export default {
    name: "nested-example",
    components: {
        StudentKeep,
        Chat,
        WorldClock,
        WorldClocksModal,
        StudentCalendarModal
    },
    display: "Nested",
    order: 15,
    mounted() {
    },
    created() {
        this.id = this.courseId;

        let $end = "/api/is-free-course/" + this.id;
        let self = this;
        axios
            .get($end)
            .then(function (response) {
                self.freeCourse = response.data;

                if (self.id && Number.isInteger(self.id)) {
                    self.getCourse();
                    if (!self.preview && !self.freeCourse) {
                        self.getCourseStudent();
                    }
                }
            })
            .catch(err => {
                console.log(err);
                this.$data.loader = false;
            });
    },
    props: {
        courseId: {
            type: Number,
            default: 0
        },
        studentCourseId: {
            type: Number,
            default: 0
        },
        preview: Number,
        userId: {
            type: Number,
            default: 0
        }
    },
    watch: {
        courseDone: function (newVal, oldVal) {
            if (newVal === true && !this.preview && !this.freeCourse) {
                this.courseStudent();
            }
        },
        quizDone: function (newVal, oldVal) {
        },
        userId: function (val) {
            console.log(val);
        }
    },
    data: function () {
        return {
            id: null,
            token: null,
            passedCourse: 0,
            freeCourse: 0,
            sliderValue: 0,
            course: [],
            lessonsNo: 0,
            quizzesNo: 0,
            quizzesNoCert: 0,
            student: null,
            courseName: "",
            courseDescription: "",
            keepSections: [],
            sections: [],
            sectionGoals: [],
            map: [],
            active: 0,
            sectionActive: 0,
            chapterActive: 0,
            lessonActive: 0,
            quizActive: 0,
            lessonQuizActive: 0,
            sectionStart: true,
            chapterStart: true,
            quizStart: true,
            quizChapter: false,
            courseDone: false,
            showCertificate: 0,
            show_certificate_when: 0,
            certificate: [],
            mobileTab: "map",
            courseNoPased: false,
            output: null,
            showWorldClocks: false,
            currentUser: null,
            showChat: false,
            unreadChatMessages: 0,
            showCalendarModal: false,
            displayFinishButton: false,
            showStudentKeep: false,
            keepTriggerData: {},
            courseFinishMessage: '',
            passedLessonsHidden: false,
        };
    },
    methods: {
        togglePassed() {
            if (this.passedLessonsHidden) {
                Array.from(document.querySelectorAll('.passed.d-none')).forEach(element => element.classList.remove('d-none'));
                Array.from(document.querySelectorAll('.section-child.d-none')).forEach(element => element.classList.remove('d-none'));
                Array.from(document.querySelectorAll('.map-first.d-none')).forEach(element => element.classList.remove('d-none'));
                this.passedLessonsHidden = false;
            } else {
                Array.from(document.querySelectorAll('.passed')).forEach(element => element.classList.add('d-none'));
                Array.from(document.querySelectorAll('.map-first')).forEach(mapSection => {
                    const unpassedLessons = mapSection.querySelectorAll('.map-lesson .chapter-item:not(.passed)').length;
                    const unpassedQuizzes = mapSection.querySelectorAll('.map-quiz .chapter-item:not(.passed)').length;
                    if (!unpassedLessons && !unpassedQuizzes) {
                        mapSection.classList.add('d-none');
                    } else {
                        let currentChapterElement = null;
                        // Convert HTMLCollection to Array before using forEach
                        if (mapSection.children && mapSection.children.length) {
                            Array.from(mapSection.children).forEach(mapElement => {
                                if (mapElement.classList.contains('map-wrapp')) return;
                                // Convert the nested HTMLCollection to Array too
                                if (mapElement.children && mapElement.children.length) {
                                    Array.from(mapElement.children).forEach(childrenMapElement => {
                                        if (!childrenMapElement.classList.contains('map-lesson') && !childrenMapElement.classList.contains('map-quiz')) {
                                            currentChapterElement = childrenMapElement;
                                            currentChapterElement.classList.add('d-none');
                                        } else {
                                            if (childrenMapElement.querySelectorAll('.chapter-item:not(.passed)').length) {
                                                currentChapterElement?.classList.remove('d-none');
                                            }
                                        }
                                    });
                                }
                            });
                        }
                    }
                });
                this.passedLessonsHidden = true;
            }
        },
        showModal(type) {
            $("#" + type).modal("show");
        },

        getCourseStudent(onlyCourseStatus = false) {
            let $end = "/api/get-student-course/" + this.studentCourseId;

            let self = this;
            axios
                .get($end)
                .then(function (response) {
                    response = response.data;

                    if (response.passed) {
                        self.showCertificate = true;
                    }

                    if (!onlyCourseStatus) {
                        self.keep = response.keep;
                        self.student = response.student;
                    }
                    self.passedCourse = response.passed;
                    self.sliderValue = response.passed_percentage;

                    setTimeout(function () {
                        if (response && response.lessons_passed) {
                            JSON.parse(response.lessons_passed).forEach(
                                function (lesson) {
                                    $("#map-lesson-" + lesson).addClass(
                                        "passed"
                                    );
                                    $("#map-mobile-lesson-" + lesson).addClass(
                                        "passed"
                                    );
                                }
                            );
                        }
                        if (response && response.quizzes_passed) {
                            JSON.parse(response.quizzes_passed).forEach(
                                function (quiz) {
                                    $("#map-quiz-" + quiz).addClass("passed");
                                    $("#map-mobile-quiz-" + quiz).addClass(
                                        "passed"
                                    );
                                    $("#map-quiz-" + quiz).removeClass(
                                        "failed"
                                    );
                                    $("#map-mobile-quiz-" + quiz).removeClass(
                                        "failed"
                                    );
                                }
                            );
                        }

                        if (response && response.quizzes_failed) {
                            JSON.parse(response.quizzes_failed).forEach(
                                function (quiz) {
                                    $("#map-quiz-" + quiz).addClass("failed");
                                    $("#map-mobile-quiz-" + quiz).addClass(
                                        "failed"
                                    );
                                }
                            );
                        }
                    }, 500);
                })
                .catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
        },
        getCourse: function () {
            let $end = "/api/get-student-course-api/" + this.id;
            if (this.freeCourse) {
                $end = "/api/get-free-course-api/" + this.id;
            }
            let self = this;
            // self.lessonsNo = 0;
            // self.quizzesNo = 0;
            // self.quizzesNoCert = 0;
            axios
                .get($end)
                .then(function (response) {
                    response = response.data;
                    self.token = response.token;
                    self.course = response.course;
                    self.courseName = self.course.name;
                    self.courseDescription = self.course.description;
                    self.courseFinishMessage = self.course.finish_message ?? trans.course.student_course_congratulations_msg;

                    self.show_certificate_when =
                        response.course.show_certificate_when;

                    if (
                        response.show_certificate_when &&
                        response.show_certificate_when != 1
                    ) {
                    }
                    //self.show_certificate_when = response.show_certificate_when;

                    let idxp;
                    let iId = 0;
                    self.sections = [];
                    self.map = [];
                    self.course.sections.forEach(function (section) {
                        self.sectionGoals = [];
                        if (section.section_type == 1) {
                            section.type = 1;
                            section.children = [];
                            section.iId = iId;
                            iId++;

                            let chapterStart;
                            section.lessons.forEach(function (lesson) {
                                if (
                                    (lesson.type != "quiz" ||
                                        lesson.quiz.quiz_type != "exam" ||
                                        lesson.quiz.show_exam_in_content) &&
                                    !lesson.hide &&
                                    (lesson.quiz ? !lesson.quiz.hide : true)
                                ) {
                                    lesson.type =
                                        lesson.type == "quiz"
                                            ? "quiz"
                                            : "lesson";
                                    lesson.iId = iId;
                                    section.children.push(lesson);
                                    iId++;
                                }
                            });
                            self.map.push(section);
                            idxp = self.map.length - 1;

                            if (section.goal_blocks) {
                                self.sectionGoals = JSON.parse(
                                    section.goal_blocks
                                );
                            }
                        }
                        if ([2, 3, 4].includes(section.section_type)) {
                            section.type = section.section_type;
                            section.iId = iId;
                            iId++;
                            self.map[idxp].children.push(section);
                            section.lessons.forEach(function (lesson) {
                                if (
                                    (lesson.type != "quiz" ||
                                        lesson.quiz.quiz_type != "exam" ||
                                        lesson.quiz.show_exam_in_content) &&
                                    !lesson.hide &&
                                    (lesson.quiz ? !lesson.quiz.hide : true)
                                ) {
                                    lesson.type =
                                        lesson.type == "quiz"
                                            ? "quiz"
                                            : "lesson";
                                    lesson.iId = iId;
                                    iId++;
                                    self.map[idxp].children.push(lesson);
                                }
                            });

                            if (
                                section.goal_blocks &&
                                JSON.parse(section.goal_blocks)[0]
                            ) {
                                self.sectionGoals = JSON.parse(
                                    section.goal_blocks
                                );
                            } else {
                                let allSections = self.course.sections;

                                let pIdx = allSections.findIndex(
                                    x => x.id === section.pivot.section_parent
                                );

                                if (
                                    pIdx != -1 &&
                                    allSections[pIdx].goal_blocks &&
                                    JSON.parse(allSections[pIdx].goal_blocks)[0]
                                ) {
                                    self.sectionGoals = JSON.parse(
                                        allSections[pIdx].goal_blocks
                                    );
                                } else {
                                    pIdx = allSections.findIndex(
                                        x =>
                                            x.id ===
                                            section.pivot.chapter_parent
                                    );

                                    if (
                                        pIdx != -1 &&
                                        allSections[pIdx].goal_blocks &&
                                        JSON.parse(
                                            allSections[pIdx].goal_blocks
                                        )[0]
                                    ) {
                                        self.sectionGoals = JSON.parse(
                                            allSections[pIdx].goal_blocks
                                        );
                                    } else {
                                        pIdx = allSections.findIndex(
                                            x =>
                                                x.id ===
                                                section.pivot.subchapter_parent
                                        );
                                        if (
                                            pIdx != -1 &&
                                            allSections[pIdx].goal_blocks
                                        ) {
                                            self.sectionGoals = JSON.parse(
                                                allSections[pIdx].goal_blocks
                                            );
                                        }
                                    }
                                }
                            }
                        }

                        let data = {
                            name: section.name,
                            goal: section.goal,
                            goals: self.sectionGoals,
                            description: section.description,
                            descriptionBlocks: section.description_blocks,
                            goalBlocks: section.goal_blocks,
                            id: section.id,
                            type: section.section_type,
                            seconds: 0,
                            minutes: 0,
                            parent: section.pivot
                        };

                        self.sections.push(data);
                        let lessonsBreak = {type: 'lesson', lessons: [], goals: []};
                        section.lessons.forEach(function (lesson, keyL) {
                            // if (lesson.type != 'quiz' && !lesson.hide) {
                            //     self.lessonsNo = self.lessonsNo + 1;
                            // }
                            // if (lesson.type == 'quiz' && lesson.quiz && !lesson.quiz.hide) {
                            //     self.quizzesNo = self.quizzesNo + 1;
                            //     // if (lesson.quiz.required_graduation) {
                            //     //     self.quizzesNoCert = self.quizzesNoCert + 1;
                            //     // }
                            // }
                            let content = lesson.type == 'quiz' ? lesson.quiz.content : lesson.content;
                            let data = {
                                name: lesson.name,
                                description: lesson.description ? lesson.description : '',
                                content: content,
                                id: lesson.id,
                                type: lesson.type == 'quiz' ? 'quiz' : 'lesson',
                                showEditor: false,
                                qid: lesson.quiz_id,
                                seconds: lesson.seconds,
                                minutes: (lesson.type == 'quiz' ? lesson.quiz.time : lesson.minutes),
                                goals: self.sectionGoals,
                                quiz: lesson.quiz_id ? lesson.quiz : null,
                                keep: '<img  @click="show(content)"  data-toggle="tooltip" data-placement="top" title="Keep" class="pointer keep-image next-link" src="../images/KeeP Button.png">'
                            }


                            if (lesson.type != 'quiz' && !lesson.minutes && !lesson.seconds) {
                                //set hide minutes true if lesson has no minutes
                                self.addChapterMinutes(0, lesson, true);
                            } else {
                                //add normally
                                self.addChapterMinutes(0, lesson);
                            }

                            if (
                                (lesson.type != "quiz" ||
                                    lesson.quiz.quiz_type != "exam" ||
                                    lesson.quiz.show_exam_in_content) &&
                                !lesson.hide &&
                                (lesson.quiz ? !lesson.quiz.hide : true)
                            ) {
                                self.sections.push(data);
                            }

                            /* if (lesson.type == 'lesson') {
                             let contentData = [];
                             JSON.parse(lesson.content).forEach(function(content, keyC) {
                                 content.showEditor=false;
                                 contentData.push(content)
                             });
                             data.content = JSON.stringify(contentData);
                         }*/

                            /*if (lesson.type == 'quiz') {
                            self.sections.push(data);
                        }

                        if (lesson.type == 'lesson'){
                            lessonsBreak.lessons.push(data);
                            let nextLesson = section.lessons[keyL+1];
                            if (lesson.page_break || typeof nextLesson == 'undefined' || nextLesson.type=="quiz") {
                                lessonsBreak.goals = self.sectionGoals;
                                self.sections.push(lessonsBreak);
                                lessonsBreak = {type: 'lesson', lessons: []};
                            }
                        }*/
                        });

                        self.sections.forEach(function (section, key) {
                            if (section.seconds > 59) {
                                let minutes = parseInt(section.seconds / 60);
                                self.sections[key].minutes += minutes;
                                self.sections[key].seconds -= minutes * 60;
                            }

                            let mapIdx = self.map.findIndex(
                                x => x.id === section.id
                            );
                            if (mapIdx != -1) {
                                self.map[mapIdx].minutes =
                                    self.sections[key].minutes;
                                self.map[mapIdx].seconds =
                                    self.sections[key].seconds;
                                self.map[mapIdx].hideMinutes =
                                    self.sections[key].hideMinutes;
                            } else {
                                self.map.forEach(function (map, idxM) {
                                    mapIdx = map.children.findIndex(
                                        x => x.id === section.id
                                    );
                                    if (mapIdx != -1) {
                                        self.map[idxM].children[mapIdx].minutes = self.sections[key].minutes;
                                        self.map[idxM].children[mapIdx].seconds = self.sections[key].seconds;
                                        self.map[idxM].children[mapIdx].hideMinutes = self.sections[key].hideMinutes;
                                    }
                                });
                            }
                        });
                    });

                    if (!self.freeCourse) {
                        self.getKeepData();
                        if (!self.keep || self.keep == "") {
                            self.keep = self.course.default_keep;
                        }
                    }
                })
                .catch(err => {
                    console.log(err);
                    this.$data.loader = false;
                });
        },
        addChapterMinutes: function (map, lesson, hideMinutes = false) {
            let pIdx = this.sections.findIndex(
                x => x.id === lesson.pivot.section_id
            );
            /*let lastIndex = self.sections.length-1;*/
            let parent = this.sections[pIdx];

            this.sections[pIdx].seconds += lesson.type === 'quiz' ? 0 : lesson.seconds;
            this.sections[pIdx].minutes += lesson.type === 'quiz' ? lesson.quiz.time : lesson.minutes;
            if (hideMinutes) this.sections[pIdx].hideMinutes = true;

            if (
                typeof parent.parent != "undefined" &&
                parent.parent.section_parent
            ) {
                pIdx = this.sections.findIndex(
                    x => x.id === parent.parent.section_parent
                );
                this.sections[pIdx].seconds += lesson.type === 'quiz' ? 0 : lesson.seconds;
                this.sections[pIdx].minutes += lesson.type === 'quiz' ? lesson.quiz.time : lesson.minutes;
                if (hideMinutes) this.sections[pIdx].hideMinutes = true;
            }
            if (
                typeof parent.parent != "undefined" &&
                parent.parent.chapter_parent
            ) {
                pIdx = this.sections.findIndex(
                    x => x.id === parent.parent.chapter_parent
                );
                this.sections[pIdx].seconds += lesson.type === 'quiz' ? 0 : lesson.seconds;
                this.sections[pIdx].minutes += lesson.type === 'quiz' ? lesson.quiz.time : lesson.minutes;
                if (hideMinutes) this.sections[pIdx].hideMinutes = true;
            }
            if (
                typeof parent.parent != "undefined" &&
                parent.parent.subchapter_parent
            ) {
                pIdx = this.sections.findIndex(
                    x => x.id === parent.parent.subchapter_parent
                );
                this.sections[pIdx].seconds += lesson.type === 'quiz' ? 0 : lesson.seconds;
                this.sections[pIdx].minutes += lesson.type === 'quiz' ? lesson.quiz.time : lesson.minutes;
                if (hideMinutes) this.sections[pIdx].hideMinutes = true;
            }
        },
        getStudentKeepData() {
            if (this.preview || this.freeCourse) {
                return;
            }

            let $end = '/api/get-student-keep/' + this.studentCourseId;
            let self = this;
            axios.get($end).then((response) => {
                response = response.data;
                this.keepSections.forEach((keepSection, index) => {
                    keepSection.content.forEach((keepEditorBlock, keepIndex) => {
                        let studentKeepContents;
                        switch (keepEditorBlock.ltype) {
                            case 1: //chapter and subchapter types
                            case 2:
                            case 3:
                            case 4:
                                studentKeepContents = response.filter((studentKeep) => studentKeep.section_id === keepEditorBlock.lid && studentKeep.keep_id === keepEditorBlock.id);
                                if (studentKeepContents.length === 1) {
                                    this.keepSections[index].content[keepIndex].keepStudent = studentKeepContents[0].keep;
                                }
                                break;
                            default: //lessons quizzes etc
                                studentKeepContents = response.filter((studentKeep) => studentKeep.lesson_id === keepEditorBlock.lid && studentKeep.keep_id === keepEditorBlock.id);
                                if (studentKeepContents.length === 1) {
                                    this.keepSections[index].content[keepIndex].keepStudent = studentKeepContents[0].keep;
                                }
                                break;
                        }
                    });
                });
                this.keepSections = [...this.keepSections];
            }).catch(err => {
                this.$data.loader = false;
            });
        },
        getKeepData: function () {
            this.keepSections = [];
            let self = this;
            this.sections.forEach(function (section) {
                let data = {
                    id: section.id,
                    name: section.name,
                    type: section.type,
                    content: [],
                }
                let parsableContent;
                if (['lesson', 'quiz'].includes(section.type)) {
                    parsableContent = section.content;
                } else {
                    parsableContent = section.descriptionBlocks;
                }

                if (parsableContent) {
                    JSON.parse(parsableContent).forEach(function (keep, idx) {
                        let dataKeep = {
                            lid: section.id, //keep container id
                            ltype: section.type, //keep container type
                            id: idx,
                            content: keep,
                            showEditor: false,
                            keepStudent: keep.keep,
                        }
                        data.content.push(dataKeep);
                    });
                }
                self.keepSections.push(data);
            });
            this.getStudentKeepData();
        },
        prevSection: function (id, skipQuizPages = false) {
            this.displayFinishButton = false;
            if (
                ["quiz"].includes(this.sections[id - 1].type) &&
                skipQuizPages
            ) {
                this.active--;
                this.prevSection(id - 1, true);
                return;
            }

            if (
                !this.passedCourse &&
                !this.preview &&
                !this.freeCourse &&
                ["lesson"].includes(this.sections[id].type)
            ) {
                this.courseStudent(this.sections[id], "lesson");
            }
            $('.middle-content').animate({scrollTop: 0}, 100);
            window.scrollTo({top: 0, behavior: "auto"});
            if (this.sections[id].type == 1) {
                $(".children-" + id).show();
            }

            if (id != 0) {
                this.active--;
                return;
            }

            return;
        },
        nextSection: async function (id, onlyNext = false) {
            let nextSection = this.sections[id + 1];
            this.displayFinishButton = this.sections[id + 2] === undefined;
            if (typeof nextSection != "undefined" && !onlyNext) {
                if (
                    !this.preview &&
                    !this.freeCourse &&
                    ["lesson"].includes(nextSection.type)
                ) {
                    this.courseStudent(nextSection, "lesson");
                }
            } else if (this.preview || this.freeCourse) {
                this.showCertificate = true;
                this.courseDone = true;
            } else {
                await this.checkCourseFinished();
            }


            $('.middle-content').animate({scrollTop: 0}, 100);
            window.scrollTo({top: 0, behavior: "auto"});
            if (this.sections[id].type == 1) {
                $(".children-" + id).show();
            }

            if (this.sections.length > id + 1) {
                this.active++;
                return;
            }
        },
        mapClick: function (sid) {
            this.displayFinishButton = this.sections[sid + 1] === undefined;
            this.courseNoPased = false;
            this.courseDone = false;
            this.active = sid;

            if (!this.preview && !this.freeCourse && ["lesson"].includes(this.sections[sid].type)) {
                this.courseStudent(this.sections[sid], "lesson");
            }
            $(window).scrollTop(0);
        },
        expandMap: function (event, element) {
            if (element.type !== 1 || !element.children.length) {
                return false;
            }
            let id = element.iId;
            $(".children-" + id).toggle();
        },
        checkCourseFinished: function () {
            let $end = "/api/check-student-course-status";
            let self = this;

            axios
                .post($end, {
                    course_id: this.id,
                    student_course_id: this.studentCourseId
                })
                .then(response => {
                    response = response.data;
                    // console.log(response);
                    this.passedCourse = !!response.studentCourse.passed;
                    this.courseNoPased = response.courseNoPassed;
                    if (this.passedCourse) {
                        this.showCertificate = true;
                        this.courseDone = true;
                    }
                });
        },
        courseStudent: function (section = false, type = false) {
            let $end = "/api/save-course-student";
            let self = this;

            axios
                .post($end, {
                    course_id: this.id,
                    student_course_id: this.studentCourseId,
                    done_lesson: type === "lesson" ? 1 : 0,
                    section: section
                })
                .then(response => {
                    if (typeof response.data.redirect != "undefined") {
                        window.location.href = response.data.redirect;
                    }
                    // console.log(response.data);
                    if (typeof response.data.studentCourse.passed_percentage != "undefined") {
                        self.sliderValue = Math.round(response.data.studentCourse.passed_percentage);
                    }

                    self.certificate = response.data.certificate;

                    let studentCourse =
                        typeof response.data.studentCourse != "undefined"
                            ? response.data.studentCourse
                            : null;

                    setTimeout(function () {
                        if (studentCourse && studentCourse.lessons_passed) {
                            JSON.parse(studentCourse.lessons_passed).forEach(
                                function (lesson) {
                                    $("#map-lesson-" + lesson).addClass(
                                        "passed"
                                    );
                                    $("#map-mobile-lesson-" + lesson).addClass(
                                        "passed"
                                    );
                                }
                            );
                        }

                        let allQuizzes = $("div.map-quiz > a > div");

                        if (studentCourse && studentCourse.quizzes_passed) {
                            JSON.parse(studentCourse.quizzes_passed).forEach(
                                function (quiz) {
                                    allQuizzes = allQuizzes
                                        .not("div#map-quiz-" + quiz)
                                        .not("div#map-mobile-quiz-" + quiz);
                                    $("#map-quiz-" + quiz)
                                        .removeClass("failed")
                                        .addClass("passed");
                                    $("#map-mobile-quiz-" + quiz)
                                        .removeClass("failed")
                                        .addClass("passed");
                                }
                            );
                        }

                        if (studentCourse && studentCourse.quizzes_failed) {
                            JSON.parse(studentCourse.quizzes_failed).forEach(
                                function (quiz) {
                                    allQuizzes = allQuizzes
                                        .not("div#map-quiz-" + quiz)
                                        .not("div#map-mobile-quiz-" + quiz);
                                    $("#map-quiz-" + quiz)
                                        .removeClass("passed")
                                        .addClass("failed");
                                    $("#map-mobile-quiz-" + quiz)
                                        .removeClass("passed")
                                        .addClass("failed");
                                }
                            );
                        }

                        allQuizzes.removeClass("failed").removeClass("passed");
                    }, 500);

                    self.passedCourse = studentCourse.passed;

                    if (type === "lesson") {
                        if (
                            self.show_certificate_when == 2 &&
                            studentCourse.done_lessons
                        ) {
                            self.showCertificate = true;
                        }
                        if (
                            self.show_certificate_when == 6 &&
                            studentCourse.done_lessons &&
                            studentCourse.done_quizzes
                        ) {
                            self.showCertificate = true;
                        }
                        if (
                            self.show_certificate_when == 5 &&
                            studentCourse.done_lessons &&
                            studentCourse.done_exam
                        ) {
                            self.showCertificate = true;
                        }
                    }

                    if (type === "quiz") {
                        if (
                            self.show_certificate_when == 4 &&
                            studentCourse.done_quizzes
                        ) {
                            self.showCertificate = true;
                        }
                        if (
                            self.show_certificate_when == 6 &&
                            studentCourse.done_lessons &&
                            studentCourse.done_quizzes
                        ) {
                            self.showCertificate = true;
                        }
                    }
                    if (type == "exam") {
                        if (
                            self.show_certificate_when == 3 &&
                            studentCourse.done_exam
                        ) {
                            self.showCertificate = true;
                        }
                        if (
                            self.show_certificate_when == 5 &&
                            studentCourse.done_lessons &&
                            studentCourse.done_exam
                        ) {
                            self.showCertificate = true;
                        }
                    }

                    if (this.passedCourse) {
                        self.showCertificate = true;
                    }

                    self.getCourse();
                })
                .catch(err => {
                    this.$data.loader = false;
                    if (isAxiosError) {
                        toastr.error(trans.messages.offline_course_progress_save_error);
                    }
                });
        },
        updateCourseStatus: function (value, data = false) {
            this.getCourseStudent(true);
        },

        onScroll({target: {scrollTop, clientHeight, scrollHeight}}) {
            if (scrollTop + clientHeight >= scrollHeight) {
            }
        },
        updateUnreadChatMessages(messageCount) {
            this.unreadChatMessages = messageCount;
        },
        navigateBack(ids) {
            this.prevSection(ids, true);
        },
        triggerKeep(data) {
            //close all previously opened sections before reopening
            this.keepSections.forEach((keepSection, index) => {
                keepSection.content.forEach((keepEditorBlock, keepIndex) => {
                    this.keepSections[index].content[keepIndex].showEditor = false;
                });
            });
            this.keepSections = [...this.keepSections];
            this.keepTriggerData = data ? data : null;
            this.showStudentKeep = true;
        },
        keepModalClosed() {
            this.showStudentKeep = false;
            this.keepTriggerData = {};
        },

    }
};
</script>

<style type="text/css">
.quizzes img {
    width: 30px;
    float: left;
    position: relative;
}

.quizzes goal-image {
    float: left;
    position: relative;
}

.goal-wrapp {
    position: relative;
}

body.modal-open {
    overflow: hidden;
}

.course-top-wrapp {
    display: flex;
    align-items: center;
}

.subnav-link .badge {
    width: 20px;
    height: 20px;
    display: flex;
    justify-content: center;
    font-size: xx-small;
}

.fontxsmall {
    font-size: x-small !important;
}

</style>

<style scoped>

.section-map {
    height: 90%;
}

.goals-list {
    height: 90%;
}

@media screen and (max-width: 1300px) {
    .section-title {
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
}

</style>
